import { Farm, MpxResponseBaseSingle, UserId } from '@cibo/core'
import { useUser } from '@cibo/profile'
import { AutocompleteFieldProps } from '@cibo/ui'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Stack } from '@mui/material'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { useLandManagement } from '../../../../../'
import { AssignFarmField } from './AssignFarmField'

export const AssignAndCreateFarmField = ({
  ownerId,
  name,
  ...autocompleteProps
}: Omit<AutocompleteFieldProps, 'name'> & {
  ownerId?: UserId
  name: string
}) => {
  const { t } = useTranslation('@cibo/landmanager/AssignFarmDialog')
  const { setFieldValue } = useFormikContext()
  const { openFarmDialog } = useLandManagement()
  const user = useUser()
  const isEditingSelf = user.data?.isGrower()

  const growerId = isEditingSelf ? user.data?.user.userId : ownerId
  const missingGrowerId = !isEditingSelf && !ownerId

  return (
    <Stack>
      <AssignFarmField
        name={name}
        farmerId={growerId}
        data-testid="select-farm"
        disabled={missingGrowerId}
        {...autocompleteProps}
      />

      <Box>
        <Button
          startIcon={<AddIcon />}
          disabled={missingGrowerId}
          onClick={() => {
            if (missingGrowerId) {
              return null
            }
            openFarmDialog({
              onSuccess: (result: MpxResponseBaseSingle<Farm>) => {
                setFieldValue(name, result.item)
              },
              ownerId: growerId,
            })
          }}
          data-testid="add-new-farm"
        >
          {t('addNewFarm')}
        </Button>
      </Box>
    </Stack>
  )
}
